import React from "react";
import { Button } from "@catchoftheday/cg-components";
import { triggerOnePassUpsellModal } from "../OnePassUpsellModal";
export const OnePassJoinToBuyButton = ({ children, onClick, ...props }) => {
    return (<Button variant={props.variant ?? "onePassPrimary"} sizeVariant="sm" onClick={(e) => {
            triggerOnePassUpsellModal();
            if (onClick) {
                onClick(e);
            }
        }} textTransform="uppercase" fontSize={{ xs: "xs", md: "base" }} fontWeight="normal" {...props}>
      {children ?? "Join to Buy"}
    </Button>);
};
